<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-1>

      <scroll-area>

        <template slot="body">

          <loader
              :show="getLoader"
              :circle="true"
              :cursor="'no-drop'"
            />

          <v-layout column fill-height ma-0 pb-1>

            <v-flex v-for="(name, index) in Object.keys(getTable)" :key="name + 'table'"  pb-2>
                <scroll-table
                  :data="getTable[name]"
                  :subscribed="false"
                  :reload="true"
                  :options="getOptions"
                  @name="(payload)=>{$emit('name', payload)}"
                  @value="(payload)=>onSelect(payload, name)"
                  @reload="()=>onReload()"
                />  
              <!-- @value="(payload)=>{$emit('value', payload)}"   -->
            </v-flex>

            <template v-for="(name, index) in Object.keys(getDescriptors)">
              <v-flex shrink v-if="getDescriptors[name].type == 'comboBox'" class="purple">
                <v-select :data-testid="$options.name + 'v-select' + name"
                  v-if="model[name]"
                  v-model="model[name].value"
                  light
                  :items="getDescriptors[name].dataModel.data"
                  :label="name"                  
                  outline         
                  hide-details
                  flat
                  class="white"
                  background-color="primary"
                  clearable
                >
                </v-select>
              </v-flex>
            </template>

            <template v-for="(name, index) in Object.keys(getDescriptors)">
              <v-flex shrink v-if="getDescriptors[name].type == 'button'"  pa-0>
                <v-btn :data-testid="$options.name + 'v-btn' + 'name'" dark small @click="" color="green">
                  {{name}}
                </v-btn>
              </v-flex>
            </template>
            
          </v-layout>

        </template>

      </scroll-area>

    </v-layout>

    <v-dialog persistent v-model="dialog.open" max-width="1000px" v-if="dialog.open">
      <rest-card
        :data="getDialogData"
        :parentData="getData"
        :addMode="getDialogMode"
        :descriptions="getDescriptions"
        :descriptors="getDescriptors"
        @update="(payload) => onUpdate(payload, 'vlanConfiguration')"
        @add="(payload) => onAdd(payload, 'vlanConfiguration')"
        @remove="(payload) => onRemove(payload, 'vlanConfiguration')"
        @close="() => onDialogClose()"
      />
    </v-dialog>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import loader from '@/nms/components/partials/loader.vue'
import RestCard from '@/nms/components/device-configuration/manage/page/rest-card.vue'

// Типы
interface DescriptorMethod {
  name: string
  rest?: string
  parameters?: Record<string, any>
  accepts?: Record<string, any>
}

interface Descriptor {
  name: string
  type?: string
  method: {
    get?: DescriptorMethod
    update?: DescriptorMethod
    add?: DescriptorMethod
    remove?: DescriptorMethod
  }
  dataModel?: {
    data?: any[]
  }
  [key: string]: any
}

interface DescriptorsMap {
  [key: string]: Descriptor
}

interface TableData {
  columns: Array<{ title: string; value: string; type: string }>
  rows: any[]
}

interface TablesMap {
  [key: string]: TableData
}

interface DialogState {
  open: boolean
  addMode: boolean
  name: string | null
  data: any | null
}

interface ModelData {
  [key: string]: any
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface ManageDeviceData {
  [key: string]: any
}

interface ActiveTreeItem {
  id?: string
  descriptor?: Descriptor | Descriptor[]
  name?: string
  [key: string]: any
}

interface StructureState {
  manage: {
    treeActive: ActiveTreeItem[]
  }
}

export default Vue.extend({
  name: 'MANAGE_DEVICE_COMPONENT',

  components: {
    scrollArea,
    scrollTable,
    loader,
    RestCard
  },

  props: {
    data: {
      type: Object as () => ManageDeviceData,
      default: () => ({})
    },
  },

  data(): {
    currentActiveTree: string | null
    loader: boolean
    treeActive: any[]
    treeOpen: any[]
    descriptors: DescriptorsMap
    descriptions: Record<string, any>
    model: ModelData
    dialog: DialogState
    options: OptionsData
    search: string
    descriptionData: Record<string, any>
    tableData: any | null
    table: TablesMap
  } {
    return {
      currentActiveTree: null,
      loader: false,
      treeActive: [],
      treeOpen: [],
      descriptors: {},
      descriptions: {},
      model: {},
      dialog: {
        open: false,
        addMode: false,
        name: null,
        data: null,
      },
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      descriptionData: {},
      tableData: null,
      table: {},
    }
  },

  computed: {
    getData(): ManageDeviceData {
      return this.data
    },
    getDialogData(): any | null {
      return this.dialog.data
    },
    getDialogMode(): boolean {
      return this.dialog.addMode
    },
    getDescriptions(): Record<string, any> {
      return this.descriptions
    },
    getDescriptors(): DescriptorsMap {
      return this.descriptors
    },
    getLoader(): boolean {
      return this.loader
    },
    getActiveTree(): ActiveTreeItem[] {
      const structure = this.$store.state.structure as StructureState
      return structure.manage.treeActive
    },
    getTable(): TablesMap {
      return this.$merge({}, this.table) as TablesMap
    },
    getOptions(): OptionsData {
      return this.options
    },
  },

  watch: {
    data: {
      handler(newVal: ManageDeviceData): void {
        this.setup('WATCH MANAGE_DEVICE_COMPONENT DATA', newVal)
      },
      deep: true
    },
    getActiveTree: {
      handler(newVal: ActiveTreeItem[]): void {
        console.log('WATCH', this.$options.name, 'getActiveTree', newVal)
        if (newVal[0]?.id && this.currentActiveTree !== newVal[0].id) {
          this.currentActiveTree = newVal[0].id
          this.setup('handler getActiveTree')
        }
      },
      deep: true
    },
  },

  created(): void {
    this.setup('created')
  },

  beforeDestroy(): void {
    this.reset()
  },

  methods: {
    setup(caller: string): void {
      console.log('MANAGE_DEVICE_COMPONENT', 'setup', 'caller', caller)
      this.reset()
      
      const activeTree = this.getActiveTree
      if (activeTree[0]?.descriptor) {
        if (Array.isArray(activeTree[0].descriptor)) {
          activeTree[0].descriptor.forEach(item => {
            this.loadDescriptorData(item)
          })
        } else {
          if (activeTree[0].descriptor.name) {
            this.loadDescriptorData(activeTree[0].descriptor)
          }
        }
      } else {
        if (activeTree[0]?.name) {
          console.log('MANAGE_DEVICE_COMPONENT', 'setup', 'getActiveTree no descriptor')
        }
      }
    },

    async loadDescriptorData(descriptor: Descriptor): Promise<void> {
      console.log('MANAGE_DEVICE_COMPONENT', 'loadDescriptorData', 'descriptor', descriptor)
      
      try {
        if (!descriptor.method?.get) {
          console.log('MANAGE_DEVICE_COMPONENT', 'loadDescriptorData', '!descriptor.method.get', descriptor)
          return
        }
        
        this.$set(this.descriptors, descriptor.name, descriptor)
        this.setLoader('loadDescriptorData', true)

        const path = descriptor.method.get.name
        const rest = descriptor.method.get.rest || 'GET'
        const params: Record<string, any> = {}
        
        if (descriptor.method.get.parameters) {
          Object.keys(descriptor.method.get.parameters).forEach(key => {
            const paramValue = descriptor.method.get!.parameters![key]
            if (typeof paramValue === 'string' && paramValue.substring(0, 1) === '$') {
              const value = Object.keys(this.getData).find(val => val === paramValue)
              if (value) {
                params[key] = this.getData[paramValue]
              } else {
                params[key] = (this as any)[paramValue]
              }
            } else {
              params[key] = paramValue
            }
          })
        }

        console.log('MANAGE_DEVICE_COMPONENT', 'loadDescriptorData', 'params', params)
        const descriptorData = await this.$bridge.customQuery('alarm', path, params, rest)
        console.log('MANAGE_DEVICE_COMPONENT', 'loadDescriptorData', 'descriptorData', descriptorData)
        
        if (descriptorData) {
          this.$set(this.descriptors[descriptor.name], 'dataModel', descriptorData)
          this.$set(this.model, descriptor.name, { value: null })
          
          if (this.descriptors[descriptor.name].type === 'table') {
            this.prepareTableData(this.descriptors[descriptor.name])
          }
        }

        this.setLoader('loadDescriptorData', false)
        console.log('MANAGE_DEVICE_COMPONENT', 'loadDescriptorData', 'this.descriptors', this.descriptors)
      } catch (error) {
        this.setLoader('loadDescriptorData', false)
        console.error('MANAGE_DEVICE_COMPONENT', 'loadDescriptorData smth wrong', error)
      }
    },

    getInnerParams(parent: Record<string, any>, obj: Record<string, any>): Record<string, any> {
      const innerParams: Record<string, any> = {}
      Object.keys(parent).forEach(innerKey => {
        if (typeof parent[innerKey] === 'object') {
          innerParams[innerKey] = this.getInnerParams(parent[innerKey], obj)
        } else if (typeof parent[innerKey] === 'string' && parent[innerKey].substring(0, 1) === '$') {
          const value = Object.keys(this.getData).find(val => val === innerKey)
          if (value) {
            innerParams[innerKey] = this.getData[innerKey]
          } else {
            innerParams[innerKey] = obj[innerKey]
          }
        } else {
          innerParams[innerKey] = parent[innerKey]
        }
      })
      console.log('MANAGE_DEVICE_COMPONENT', 'getInnerParams', 'return innerParams', innerParams)
      return innerParams
    },

    async onUpdate(val: any): Promise<void> {
      console.log('MANAGE_DEVICE_COMPONENT', 'onUpdate', 'val', val)
      
      try {
        const name = this.dialog.name
        const descriptor = this.descriptors[name as string]
        console.log('MANAGE_DEVICE_COMPONENT', 'onUpdate', 'descriptor', descriptor)
        
        if (!descriptor?.method?.update) {
          console.log('MANAGE_DEVICE_COMPONENT', 'onUpdate', '!descriptor.method.update', descriptor)
          return
        }

        const path = descriptor.method.update.name
        const rest = descriptor.method.update.rest || 'GET'
        const params: Record<string, any> = {}
        
        if (descriptor.method.update.parameters) {
          Object.keys(descriptor.method.update.parameters).forEach(key => {
            const paramValue = descriptor.method.update!.parameters![key]
            if (typeof paramValue === 'object') {
              console.log('MANAGE_DEVICE_COMPONENT', 'onUpdate', 'params OBJECT', key, paramValue)
              params[key] = this.getInnerParams(paramValue, val)
            } else if (typeof paramValue === 'string' && paramValue.substring(0, 1) === '$') {
              const foundKey = Object.keys(this.getData).find(k => k === paramValue)
              if (foundKey) {
                params[key] = this.getData[paramValue]
              } else {
                params[key] = val[key]
              }
            } else {
              params[key] = paramValue
            }
          })
        }

        console.log('MANAGE_DEVICE_COMPONENT', 'onUpdate', 'params', params)
        const descriptorData = await this.$bridge.customQuery('alarm', path, params, rest)
        console.log('MANAGE_DEVICE_COMPONENT', 'onUpdate', 'descriptorData', descriptorData)
        
        if (descriptorData && descriptor) {
          this.loadDescriptorData(descriptor)
        }
      } catch (error) {
        console.error('MANAGE_DEVICE_COMPONENT', 'onUpdate smth wrong', error)
      }
    },

    async onAdd(val: any): Promise<void> {
      console.log('MANAGE_DEVICE_COMPONENT', 'onAdd', 'val', val)
      
      try {
        const name = this.dialog.name
        const descriptor = this.descriptors[name as string]
        console.log('MANAGE_DEVICE_COMPONENT', 'onAdd', 'descriptor', descriptor)
        
        if (!descriptor?.method?.add) {
          console.log('MANAGE_DEVICE_COMPONENT', 'onAdd', '!descriptor.method.add', descriptor)
          return
        }

        const path = descriptor.method.add.name
        const rest = descriptor.method.add.rest || 'GET'
        const params: Record<string, any> = {}
        
        if (descriptor.method.add.parameters) {
          Object.keys(descriptor.method.add.parameters).forEach(key => {
            const paramValue = descriptor.method.add!.parameters![key]
            if (typeof paramValue === 'object') {
              console.log('MANAGE_DEVICE_COMPONENT', 'onAdd', 'params OBJECT', key, paramValue)
              params[key] = this.getInnerParams(paramValue, val)
            } else if (typeof paramValue === 'string' && paramValue.substring(0, 1) === '$') {
              const foundKey = Object.keys(this.getData).find(k => k === paramValue)
              if (foundKey) {
                params[key] = this.getData[paramValue]
              } else {
                params[key] = val[key]
              }
            } else {
              params[key] = paramValue
            }
          })
        }

        console.log('MANAGE_DEVICE_COMPONENT', 'onAdd', 'params', params)
        const newItem = await this.$bridge.customQuery('alarm', path, params, rest)
        console.log('MANAGE_DEVICE_COMPONENT', 'onAdd', 'newItem', newItem)
        
        if (newItem && descriptor) {
          this.loadDescriptorData(descriptor)
        }
      } catch (error) {
        console.error('MANAGE_DEVICE_COMPONENT', 'onAdd smth wrong', error)
      }
    },

    async onRemove(val: any): Promise<void> {
      console.log('MANAGE_DEVICE_COMPONENT', 'onRemove', 'val', val)
      
      try {
        const name = this.dialog.name
        const descriptor = this.descriptors[name as string]
        console.log('MANAGE_DEVICE_COMPONENT', 'onRemove', 'descriptor', descriptor)
        
        if (!descriptor?.method?.remove) {
          console.log('MANAGE_DEVICE_COMPONENT', 'onRemove', '!descriptor.method.remove', descriptor)
          return
        }

        const path = descriptor.method.remove.name
        const rest = descriptor.method.remove.rest || 'GET'
        const params: Record<string, any> = {}
        
        if (descriptor.method.remove.parameters) {
          Object.keys(descriptor.method.remove.parameters).forEach(key => {
            const paramValue = descriptor.method.remove!.parameters![key]
            if (typeof paramValue === 'object') {
              console.log('MANAGE_DEVICE_COMPONENT', 'onRemove', 'params OBJECT', key, paramValue)
              params[key] = this.getInnerParams(paramValue, val)
            } else if (typeof paramValue === 'string' && paramValue.substring(0, 1) === '$') {
              const foundKey = Object.keys(this.getData).find(k => k === paramValue)
              if (foundKey) {
                params[key] = this.getData[paramValue]
              } else {
                params[key] = val[key]
              }
            } else {
              params[key] = paramValue
            }
          })
        }

        console.log('MANAGE_DEVICE_COMPONENT', 'onRemove', 'params', params)
        const result = await this.$bridge.customQuery('alarm', path, params, rest)
        console.log('MANAGE_DEVICE_COMPONENT', 'onRemove', 'result', result)
        
        if (result && descriptor) {
          this.loadDescriptorData(descriptor)
        }
      } catch (error) {
        console.error('MANAGE_DEVICE_COMPONENT', 'onRemove smth wrong', error)
      }
    },

    async prepareTableData(payload: Descriptor): Promise<void> {
      console.log('MANAGE_DEVICE_COMPONENT', 'prepareTableData', 'payload', payload)
      
      this.$set(this.table, payload.name, { columns: [], rows: [] })
      
      if (payload.dataModel?.data?.length) {
        try {
          this.setLoader('prepareTableData', true)
          
          Object.keys(payload.dataModel.data[0]).forEach(field => {
            this.table[payload.name].columns.push({
              title: field,
              value: field,
              type: 'text',
            })
          })
          
          this.table[payload.name].rows = payload.dataModel.data
          this.setLoader('prepareTableData', false)
        } catch (error) {
          console.error('MANAGE_DEVICE_COMPONENT', 'prepareTableData smth wrong', error)
          this.setLoader('prepareTableData', false)
        }
      }
    },

    onSelect(val: any, name: string): void {
      console.log('MANAGE_DEVICE_COMPONENT', 'onSelect', 'val', val)
      console.log('MANAGE_DEVICE_COMPONENT', 'onSelect', 'name', name)
      
      if (val) {
        this.$set(this.dialog, 'data', val)
        this.$set(this.dialog, 'name', name)
        this.$set(this.dialog, 'open', true)
      }
    },

    onDialogClose(): void {
      console.log('MANAGE_DEVICE_COMPONENT', 'onDialogClose')
      this.$set(this.dialog, 'data', null)
      this.$set(this.dialog, 'name', null)
      this.$set(this.dialog, 'addMode', false)
      this.$set(this.dialog, 'open', false)
    },

    onReload(): void {
      console.log('MANAGE_DEVICE_COMPONENT', 'onReload')
      this.setup('onReload')
    },

    onCreate(name: string): void {
      console.log('MANAGE_DEVICE_COMPONENT', 'onCreate')
      
      const descriptor = this.descriptors[name]
      if (!descriptor) {
        console.log('MANAGE_DEVICE_COMPONENT', 'onCreate', '!name', name)
        return
      }
      if (!descriptor.method?.add) {
        console.log('MANAGE_DEVICE_COMPONENT', 'onCreate', '!descriptor.method.add', descriptor)
        return
      }

      const obj: Record<string, any> = {}
      if (descriptor.method.add.parameters?.accepts) {
        Object.keys(descriptor.method.add.parameters.accepts).forEach(key => {
          obj[key] = null
        })
      }

      this.$set(this.dialog, 'data', obj)
      this.$set(this.dialog, 'name', name)
      this.$set(this.dialog, 'addMode', true)
      this.$set(this.dialog, 'open', true)
    },

    setLoader(name: string, status: boolean): void {
      this.loader = status
    },

    reset(): void {
      this.search = ''
      this.descriptionData = {}
      this.tableData = null
      this.table = {}
      this.descriptors = {}
      this.model = {}
    },
  },
})
</script>

<style lang="css" scoped>
</style>
